import { render, staticRenderFns } from "./RinvPD_Items.vue?vue&type=template&id=255be8dc"
import script from "./RinvPD_Items.vue?vue&type=script&lang=js"
export * from "./RinvPD_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports